export default "__VITE_ASSET__6c47abde__"